<!-- Upload Pix for Article -->

<template>
	<div class="upload-pix">
		
		<div class="up-header" >
			
			<div class="select-box">
				<input 
					style="display: none"
					type="file" 
					@change="picFileIsChosen" 
					ref="myFileInput"
				/>
				<button
				 	v-if="pix.length < maxUplPix" 
					class="select-btn"
					@click="mess=[]; $refs.myFileInput.click()"
					>
					Select an Image
				</button>
			</div>
		
			<span :class="pix.length < maxUplPix? 'std-mess': 'err-mess'">Maximum Images: {{ maxUplPix }}</span> 

		
		</div>


		<div v-for="(rec, idx) in pix" :key="'pic'+idx">
			<UploadPixDetail
				:rec="rec"
				:idx="idx"
			/>

			<div class="v-spacer" />
		</div>


	</div>
</template>

<script>
import { m } from "@/utils/utils";
import CfgApp from "@/assets/cfg/CfgApp.json";
import * as PixUtils from "@/utils/pix_utils.js";
import { mapState, mapGetters } from "vuex";
import UploadPixDetail from '@/components/UploadPixDetail';
import * as Classes from "@/classes/classes";
const step = "upload";

export default {
	data() {
		return {
			maxUplPix: CfgApp.maxUplPix
		}
	},
	components: {
		UploadPixDetail,
	},
	computed: {
		// ...mapState('app', ['upload']),
		...mapState({
			pix: state => state.app[step].pix,
		}),
	},
	methods: {
		clickTest() {
			m("click test");
		},

		// New file tp upload has been selected
		picFileIsChosen(evt) {
			m("file is chosen", evt.target.files);
			document.activeElement.blur();
			let data = {
				files: evt.target.files,
			};
			this.$store.dispatch("app/uploadPic", data);
		}

	},
	mounted() {
		m("upl pix mounted", this.pix);
	},
	updated() {
		// this.pix = this[step].pix;
		m("upload updated =====================");
	},
	watch: {
		uploadXXX: {
			deep:true,
			handler: (oldVal, newVal) => {
				m("upload watch changed =====================");
			},
		}
	}
}
</script>

<style scoped>

.upload-pix {
	height: 100%;
	overflow: hidden;
	padding: 10px;
	border: solid 0px #C30;
}

.v-spacer {
	width: 10px;
	height: 10px;
	overflow: hidden;
	border: solid 0px #999;
}

.up-header {
	height: 30px;
	overflow: hidden;
	vertical-align: top;
	padding: 0px 0px 0px 10px;
	border: solid 0px #666;
}

.select-box {
	display: inline-block;
	width: 170px;
	height: 25px;
	overflow: hidden;
	vertical-align: top;
	padding: 0px 0px 0px 5px;
	border: solid 0px #369;
}

.select-btn {
	width: 140px;
}

.std-mess {
	color: #000;
}

.err-mess {
	color: #C30;
	font-size: 16px;
	font-weight: bold;
}



</style>
